import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';
import { normalize, schema } from 'normalizr';

const FACEBOOK_PLATFORM_ID = 3;

const socialAccountsList = new schema.Entity('socialAccountsList', undefined, {
    idAttribute: value => {
        return value.account.platformUserId;
    },
});

const getFacebookLinkedAccounts = store => async (state, clientId) => {
    const userClientId = state.user.selectedUserClientId;

    const loadingState = R.assocPath(
        [
            'clients',
            userClientId,
            'socialAccounts',
            'facebook',
            'isRequestingLinkedPages',
        ],
        true,
        state,
    );
    store.setState(loadingState);

    const response = await sportsApi
        .url(`/clients/${clientId}/authorized-accounts`)
        .query({ platformId: FACEBOOK_PLATFORM_ID })
        .get()
        .json();

    const normalizedData = normalize(response, [socialAccountsList]);

    const pages = normalizedData.entities.socialAccountsList || {};

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        socialAccounts: {
                            facebook: {
                                isRequestingLinkedPages: R.always(false),
                                linkedPages: R.always(pages),
                            },
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default getFacebookLinkedAccounts;
